import React from 'react';
import { connect } from 'react-redux';
import FormFields from 'containers/request/Payments/PaymentFormFields';

const PaymentFormStaff = ({ user, request }) => {
  return user.isStaff && user.canEditRequest && request.invoice.paid ? (
    <FormFields />
  ) : null;
};

function mapStateToProps({ user, request }) {
  return { user, request };
}

export default connect(mapStateToProps)(PaymentFormStaff);



// WEBPACK FOOTER //
// ./src/containers/request/Payments/PaymentFormStaff.js